import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reports-sidebar" }
const _hoisted_2 = { class: "sidebar-section" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar-list"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "sidebar-report-name" }
const _hoisted_6 = { class: "sidebar-menu" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "sidebar-dropdown"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "sidebar-empty"
}
const _hoisted_12 = { class: "sidebar-section" }
const _hoisted_13 = {
  key: 0,
  class: "sidebar-list"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "sidebar-report-name" }
const _hoisted_16 = { class: "sidebar-menu" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "sidebar-dropdown"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "sidebar-empty"
}

import { ref, onMounted, onUnmounted } from "vue";
import { useReportsStore } from "@/store/store/reportsStore";
import type { ReportItem } from "@/types/reports";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsSidebar',
  emits: ["open-report", "open-by-id"],
  setup(__props, { emit: __emit }) {

const reportsStore = useReportsStore();

const emit = __emit;

const openFavMenuId = ref<number | null>(null);
const openRecentMenuId = ref<number | null>(null);

function toggleFavMenu(id: number) {
  openFavMenuId.value = openFavMenuId.value === id ? null : id;
  openRecentMenuId.value = null;
}

function toggleRecentMenu(id: number) {
  openRecentMenuId.value = openRecentMenuId.value === id ? null : id;
  openFavMenuId.value = null;
}

function closeMenus() {
  openFavMenuId.value = null;
  openRecentMenuId.value = null;
}

function viewReport(report: ReportItem) {
  emit("open-report", report);
  closeMenus();
}

function viewById(id: number) {
  emit("open-by-id", id);
  closeMenus();
}

function unfavoriteReport(report: ReportItem) {
  reportsStore.toggleFavorite(report);
  closeMenus();
}

onMounted(() => document.addEventListener("click", closeMenus));
onUnmounted(() => document.removeEventListener("click", closeMenus));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "sidebar-heading" }, "Favorites", -1)),
      (_unref(reportsStore).favoriteReports.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportsStore).favoriteReports, (report) => {
              return (_openBlock(), _createElementBlock("li", {
                key: report.id,
                class: "sidebar-item"
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "sidebar-report-btn",
                  onClick: ($event: any) => (viewReport(report))
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(report.displayName), 1)
                ], 8, _hoisted_4),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "sidebar-kebab",
                    onClick: _withModifiers(($event: any) => (toggleFavMenu(report.id)), ["stop"])
                  }, "⋮", 8, _hoisted_7),
                  (openFavMenuId.value === report.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sidebar-dropdown-item",
                          onClick: ($event: any) => (viewReport(report))
                        }, "View", 8, _hoisted_9),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sidebar-dropdown-item",
                          onClick: ($event: any) => (unfavoriteReport(report))
                        }, "Unfavorite", 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_11, "No favorites yet."))
    ]),
    _createElementVNode("section", _hoisted_12, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "sidebar-heading" }, "Recently Viewed", -1)),
      (_unref(reportsStore).recentlyViewed.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportsStore).recentlyViewed, (entry) => {
              return (_openBlock(), _createElementBlock("li", {
                key: entry.id,
                class: "sidebar-item"
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "sidebar-report-btn",
                  onClick: ($event: any) => (viewById(entry.id))
                }, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(entry.displayName), 1)
                ], 8, _hoisted_14),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "sidebar-kebab",
                    onClick: _withModifiers(($event: any) => (toggleRecentMenu(entry.id)), ["stop"])
                  }, "⋮", 8, _hoisted_17),
                  (openRecentMenuId.value === entry.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sidebar-dropdown-item",
                          onClick: ($event: any) => (viewById(entry.id))
                        }, "View", 8, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_20, "Nothing viewed yet."))
    ])
  ]))
}
}

})